import { IWindowable } from "../UIManagerInterfaces";
import { IContentBuilder } from "./IContentBuilder";
/**
 * Builder zprostředkovávající obsah formuláře do okna
 * @includeToDoc
 */
export class FormContentBuilder implements IContentBuilder {
    private readonly _window?: IWindowable;

    /**
     * @param window Okno, ktere se má otevřít v MessageWindow
     */
    constructor(window: IWindowable) {
        this._window = window;
    }

    public async build(): Promise<HTMLElement> {
        return this._window.getElement();
    }
}
